// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastBackwardFilledSvg from "@fishx/icons-svg/es/asn/FastBackwardFilled";
import FishxIcon from '../components/FishxIcon';

var FastBackwardFilled = function FastBackwardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastBackwardFilledSvg
  }));
};

FastBackwardFilled.displayName = 'FastBackwardFilled';
export default React.forwardRef(FastBackwardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FastBackwardFilled.js
// module id = 2663
// module chunks = 0